import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
    baseURL: API_BASE,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Handle auth errors
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            if (window.location.pathname.startsWith('/admin') || window.location.pathname.startsWith('/team')) {
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);

// Auth
export const authAPI = {
    register: (data) => api.post('/auth/register', data),
    login: (data) => api.post('/auth/login', data),
    getMe: () => api.get('/auth/me'),
};

// Services
export const servicesAPI = {
    getAll: (params) => api.get('/services', { params }),
    create: (data) => api.post('/services', data),
    update: (id, data) => api.put(`/services/${id}`, data),
    delete: (id) => api.delete(`/services/${id}`),
};

// Barbers
export const barbersAPI = {
    getAll: (params) => api.get('/barbers', { params }),
    getActive: () => api.get('/barbers/active'),
    create: (data) => api.post('/barbers', data),
    update: (id, data) => api.put(`/barbers/${id}`, data),
    delete: (id) => api.delete(`/barbers/${id}`),
    toggleAvailability: (staff_key, disabled) => api.put('/staff-availability', { staff_key, disabled }),
};

// Appointments
export const appointmentsAPI = {
    getAvailableSlots: (date, staffKey, serviceKey) => 
        api.get('/appointments/available-slots', { params: { date, staff_key: staffKey, service_key: serviceKey } }),
    create: (data) => api.post('/appointments', data),
    getAll: (params) => api.get('/appointments', { params }),
    updateStatus: (id, status) => api.put(`/appointments/${id}/status`, { status }),
};

// Dashboard
export const dashboardAPI = {
    getStats: () => api.get('/dashboard/stats'),
};

// Promotions
export const promotionsAPI = {
    getBanner: () => api.get('/promo-banner'),
    updateBanner: (data) => api.put('/promo-banner', data),
};

export const vipPerksAPI = {
    get: () => api.get('/vip-perks'),
    update: (data) => api.put('/vip-perks', data),
};

export const mediaAPI = {
    getSettings: () => api.get('/media-settings'),
    updateSettings: (data) => api.put('/media-settings', data),
    upload: (formData) => api.post('/uploads', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    }),
};

// Seed data
export const seedAPI = {
    seed: () => api.post('/seed'),
};

export default api;
